export default __webpack_public_path__ + "static/1-d436f9212b89247d14c7d60c2813b645.jpeg";